module.exports = __webpack_public_path__ + "static/image/history/pc/201601@3x.ver2_0_2.jpg?2d20dabb";